<template>
<div class="chapter">
<div class="inner_page">
<div>
<span class="pagebreak" id="page7" title="7"></span>
<h2 class="chapter-title---IVP" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h2>
<div>
<div id="_idContainer005">
<p class="veryfirst"><a href="#/Text/part1#_idTextAnchor001"><b>Part One: Bottom</b></a></p>
<blockquote>
<p class="verse"><a href="#/Text/ch1#_idTextAnchor003">1 Uncle</a></p>
<p class="versefirst"><a href="#/Text/ch2#_idTextAnchor005">2 Why Are You Smiling?</a></p>
<p class="versefirst"><a href="#/Text/ch3#_idTextAnchor007">3 Major Depressive Disorder</a></p>
<p class="versefirst"><span href="#/Text/ch4#_idTextAnchor009" title="Link target outside of Sample">4 Who Am I?</span></p>
<p class="versefirst"><span href="#/Text/ch5#_idTextAnchor011" title="Link target outside of Sample">5 Help</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part2#_idTextAnchor012" title="Link target outside of Sample"><b>Part Two: Borderline</b></span></p>
<blockquote>
<p class="verse"><span href="#/Text/ch6#_idTextAnchor014" title="Link target outside of Sample">6 Home</span></p>
<p class="versefirst"><span href="#/Text/ch7#_idTextAnchor016" title="Link target outside of Sample">7 Bad Mom</span></p>
<p class="versefirst"><span href="#/Text/ch8#_idTextAnchor018" title="Link target outside of Sample">8 Origins</span></p>
<p class="versefirst"><span href="#/Text/ch9#_idTextAnchor020" title="Link target outside of Sample">9 Work the Program</span></p>
<p class="versefirst"><span href="#/Text/ch10#_idTextAnchor022" title="Link target outside of Sample">10 The Color System</span></p>
<p class="versefirst"><span href="#/Text/ch11#_idTextAnchor024" title="Link target outside of Sample">11 Will the Real Depression Please Stand Up?</span></p>
<p class="versefirst"><span href="#/Text/ch12#_idTextAnchor026" title="Link target outside of Sample">12 Escape</span></p>
<p class="versefirst"><span href="#/Text/ch13#_idTextAnchor028" title="Link target outside of Sample">13 The Lord’s Prayer</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part3#_idTextAnchor029" title="Link target outside of Sample"><b>Part Three: Breakt­hroughs</b></span></p>
<blockquote>
<p class="verse"><span href="#/Text/ch14#_idTextAnchor031" title="Link target outside of Sample">14 Thaw</span></p>
<p class="versefirst"><span href="#/Text/ch15#_idTextAnchor033" title="Link target outside of Sample">15 Polygamy</span></p>
<p class="versefirst"><span href="#/Text/ch16#_idTextAnchor035" title="Link target outside of Sample">16 Hide</span></p>
<p class="versefirst"><span href="#/Text/ch17#_idTextAnchor037" title="Link target outside of Sample">17 And Seek</span></p>
<p class="versefirst"><span href="#/Text/ch18#_idTextAnchor039" title="Link target outside of Sample">18 Grow</span></p>
<p class="versefirst"><span href="#/Text/ch19#_idTextAnchor041" title="Link target outside of Sample">19 Shame</span></p>
<p class="versefirst"><span class="pagebreak" id="page8" title="8"></span><span href="#/Text/ch20#_idTextAnchor043" title="Link target outside of Sample">20 Best Mom</span></p>
<p class="versefirst"><span href="#/Text/ch21#_idTextAnchor045" title="Link target outside of Sample">21 Faith</span></p>
<p class="versefirst"><span href="#/Text/ch22#_idTextAnchor047" title="Link target outside of Sample">22 Forced Praise</span></p>
<p class="versefirst"><span href="#/Text/ch23#_idTextAnchor049" title="Link target outside of Sample">23 Still Life</span></p>
</blockquote>
<p class="firstleft"><span href="#/Text/acknowledgments#_idTextAnchor050" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/praise#_idTextAnchor051" title="Link target outside of Sample">Praise for <i class="i">Still Life</i></span></p>
<p class="firstleft"><span href="#/Text/author#_idTextAnchor052" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/crescendo#_idTextAnchor053" title="Link target outside of Sample">IVP Crescendo</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#_idTextAnchor054" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstleft"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
<p class="body"><span class="pagebreak" id="page9" title="9"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?54c9450e